'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { ChartConfigManager } from '@benzinga/chart-config-manager';

export const useChartsDrawing = () => {
  const session = React.useContext(SessionContext);

  const [charts, setCharts] = React.useState(() => session.getManager(ChartConfigManager).getCachedDrawingCharts());
  React.useEffect(() => {
    session.getManager(ChartConfigManager).getDrawingCharts();
  }, [session]);

  Hooks.useSubscriber(session.getManager(ChartConfigManager), event => {
    switch (event.type) {
      case 'chart-config:drawing-charts-updated':
        setCharts(event.charts);
        break;
    }
  });

  return charts;
};
